import {
  getBooleanField,
  getDateField,
  getEmailField,
  getExceptQueryDangerousSymbolsTextField,
  getExceptSpecialSymbolsTextField,
  getFloatField,
  getIntegerField,
  getPhoneNumberField,
  getSsnField,
} from '@lender/utils';

import {
  getCheckboxField,
  getCheckboxGroupField,
  getCurrencyFloatField,
  getExceptDigitsTextField,
  getNonUSZipField,
  getSpecificPatternTextField,
  getZipField,
} from 'utils/validation';

import { FieldInputType } from './fields';

export const NO_BOOLEAN_INPUT_PROPS = { 'data-noboolean': true };

export const FieldType = {
  INPUT: 'input',
  COMBINED: 'combined',
  SELECT: 'select',
  CHECKBOX: 'checkbox',
  CHECKBOX_GROUP: 'checkboxGroup',
  RADIO: 'radio',
  EXTENDABLE_RADIO: 'extendedRadio',
  ADDRESS: 'address',
  DATE: 'date',
  TEL: 'tel',
  TEL_EXT: 'tel_ext',
  GROUP: 'group',
  TEXTAREA: 'textarea',
  RICH_TEXTAREA: 'rich_textarea',
  SWITCH: 'switch',
  EMPTY: 'empty',
};

export const FieldInputTypeValidation = {
  [FieldInputType.EMAIL]: getEmailField,
  [FieldInputType.INT]: getIntegerField,
  [FieldInputType.ZIP]: getZipField,
  [FieldInputType.NON_US_ZIP]: getNonUSZipField,
  [FieldInputType.BOOL]: getBooleanField,
  [FieldInputType.FLOAT]: getFloatField,
  [FieldInputType.DATE]: getDateField,
  [FieldInputType.CURRENCY]: getCurrencyFloatField,
  [FieldInputType.TEL]: getPhoneNumberField,
  [FieldInputType.TEL_EXT]: getPhoneNumberField,
  [FieldInputType.SSN]: getSsnField,
  [FieldInputType.TEXT_EXCEPT_DIGITS]: getExceptDigitsTextField,
  [FieldInputType.TEXT_EXCEPT_SPECIAL_SYMBOLS]: getExceptSpecialSymbolsTextField,
  [FieldInputType.TEXT_EXCEPT_QUERY_DANGEROUS_SYMBOLS]: getExceptQueryDangerousSymbolsTextField,
  [FieldInputType.TEXT_SPECIFIC_PATTERN]: getSpecificPatternTextField,
  [FieldType.CHECKBOX_GROUP]: getCheckboxGroupField,
  [FieldType.CHECKBOX]: getCheckboxField,
};
